import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import dashDotted from '@/images/toolbar/stroke/DashDotted.svg';
import dashSolid from '@/images/toolbar/stroke/DashSolid.svg';
import dashThick from '@/images/toolbar/stroke/DashThick.svg';
import dashThin from '@/images/toolbar/stroke/DashThin.svg';
import { ControlButton } from '@/pages/AdvancedEditor/components/panels/common/ControlButton';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';

const Container = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
`;

export enum DASH_TYPE {
    SOLID = 'solid',
    DASHED_THICK = 'dashed_thick',
    DASHED_THIN = 'dashed_thin',
    DOTTED = 'dotted',
}

const dashVariants: Record<DASH_TYPE, number[]> = {
    [DASH_TYPE.SOLID]: [],
    [DASH_TYPE.DASHED_THICK]: [4, 1],
    [DASH_TYPE.DASHED_THIN]: [2, 1],
    [DASH_TYPE.DOTTED]: [1, 1],
};

export const BorderStyleControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedShapes;
    const element = elements[0] as ElementType & { dash: number[] };

    if (!element) return null;

    const toggleStyles = (variant: DASH_TYPE) => {
        elements.forEach(element => element.set({ dash: dashVariants[variant] }));
    };

    return (
        <Container>
            <ControlButton
                onClick={() => toggleStyles(DASH_TYPE.SOLID)}
                selected={element.dash.toString() === dashVariants[DASH_TYPE.SOLID].toString()}>
                <MaskedIcon src={dashSolid} size="16px" />
            </ControlButton>
            <ControlButton
                onClick={() => toggleStyles(DASH_TYPE.DASHED_THICK)}
                selected={element.dash.toString() === dashVariants[DASH_TYPE.DASHED_THICK].toString()}>
                <MaskedIcon src={dashThick} size="16px" />
            </ControlButton>
            <ControlButton
                onClick={() => toggleStyles(DASH_TYPE.DASHED_THIN)}
                selected={element.dash.toString() === dashVariants[DASH_TYPE.DASHED_THIN].toString()}>
                <MaskedIcon src={dashThin} size="16px" />
            </ControlButton>
            <ControlButton
                onClick={() => toggleStyles(DASH_TYPE.DOTTED)}
                selected={element.dash.toString() === dashVariants[DASH_TYPE.DOTTED].toString()}>
                <MaskedIcon src={dashDotted} size="16px" />
            </ControlButton>
        </Container>
    );
});
